<template>
    <div class="item-specs">
        <h3><slot>Spec Label</slot></h3>
        <ul v-if="topic === 'dimensions'">
            <li>
                <p class="label-container">{{t('compare.form')}}</p>
                <p v-if="data.compare_form" class="value">{{ data.compare_form }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <p class="label-container">{{t('compare.spannweite')}}</p>
                <p v-if="data.compare_spannweite" class="value">{{ data.compare_spannweite }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <p class="label-container" style="min-height: 60px">{{t('compare.hoehe')}}</p>
                <p v-if="data.compare_hoehe" class="value">{{ data.compare_hoehe }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <p class="label-container">{{t('compare.durchgangshoehe')}}</p>
                <p v-if="data.compare_durchgangshoehe" class="value">{{ data.compare_durchgangshoehe }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <p class="label-container">{{t('compare.schliesshoehe')}}</p>
                <p v-if="data.compare_schliesshoehe" class="value">{{ data.compare_schliesshoehe }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <p class="label-container">{{t('compare.schirmgewicht')}}</p>
                <p v-if="data.compare_schirmgewicht" class="value">{{ data.compare_schirmgewicht }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <p class="label-container">{{t('compare.windstabilitaet')}}</p>
                <p v-if="data.compare_windstabilitaet" class="value">{{ data.compare_windstabilitaet }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <p class="label-container">{{t('compare.gestellfarbe')}}</p>
                <p v-if="data.compare_gestellfarbe" class="value">{{ data.compare_gestellfarbe }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <p class="label-container">{{t('compare.teiligkeit')}}</p>
                <p v-if="data.compare_teiligkeit" class="value">{{ data.compare_teiligkeit }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <p class="label-container">{{t('compare.material')}}</p>
                <p v-if="data.compare_material" class="value">{{ data.compare_material }}</p>
                <p v-else class="value">–</p>
            </li>
        </ul>

        <ul v-if="topic === 'quality'">
            <li>
                <div class="label-container">
                    <p class="label">{{t('compare.stoffklasse')}}
                        <span class="icon" v-if="tooltips.compare_stoffklasse_tooltip">
                            <inline-svg :src="'/img/icon_info.svg'"/>
                            <div class="tooltip-compare">
                                <div class="text">{{tooltips.compare_stoffklasse_tooltip}}</div>
                            </div>
                        </span>
                    </p>

                </div>
                <p v-if="data.compare_stoffklasse" class="value">{{ data.compare_stoffklasse }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <p class="label-container">{{t('compare.volant')}}</p>
                <p v-if="data.compare_volant" class="value">{{ data.compare_volant }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <div class="label-container">
                    <p class="label">{{t('compare.uvschutz')}}
                        <span class="icon" v-if="tooltips.compare_uvschutz_tooltip">
                            <inline-svg :src="'/img/icon_info.svg'"/>
                            <div class="tooltip-compare">
                                <div class="text">{{tooltips.compare_uvschutz_tooltip}}</div>
                            </div>
                        </span>
                    </p>
                </div>
                <p v-if="data.compare_uvschutz" class="value">{{ data.compare_uvschutz }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <div class="label-container">
                    <p class="label">{{t('compare.flaechengewicht')}}
                        <span class="icon" v-if="tooltips.compare_flaechengewicht_tooltip">
                            <inline-svg :src="'/img/icon_info.svg'"/>
                            <div class="tooltip-compare">
                                <div class="text">{{tooltips.compare_flaechengewicht_tooltip}}</div>
                            </div>
                        </span>
                    </p>

                </div>
                <p v-if="data.compare_flaechengewicht" class="value">{{ data.compare_flaechengewicht }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <div class="label-container">
                    <p class="label">{{t('compare.lichtechtheit')}}
                        <span class="icon" v-if="tooltips.compare_lichtechtheit_tooltip">
                            <inline-svg :src="'/img/icon_info.svg'"/>
                            <div class="tooltip-compare">
                                <div class="text">{{tooltips.compare_lichtechtheit_tooltip}}</div>
                            </div>
                        </span>
                    </p>
                </div>
                <p v-if="data.compare_lichtechtheit" class="value">{{ data.compare_lichtechtheit }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <div class="label-container">
                    <p class="label">{{t('compare.wassersaeule')}}
                        <span class="icon" v-if="tooltips.compare_wassersaeule_tooltip">
                            <inline-svg :src="'/img/icon_info.svg'"/>
                            <div class="tooltip-compare">
                                <div class="text">{{tooltips.compare_wassersaeule_tooltip}}</div>
                            </div>
                        </span>
                    </p>
                </div>
                <p v-if="data.compare_wassersaeule" class="value">{{ data.compare_wassersaeule }}</p>
                <p v-else class="value">–</p>
            </li>
        </ul>

        <ul v-if="topic === 'accessories'">
            <li>
                <p class="label-container">{{t('compare.befestigung')}}</p>
                <p v-if="data.compare_befestigung" class="value">{{ data.compare_befestigung }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <p class="label-container">{{t('compare.beleuchtung')}}</p>
                <p v-if="data.compare_beleuchtung" class="value">{{ data.compare_beleuchtung }}</p>
                <p v-else class="value">–</p>
            </li>
            <li>
                <p class="label-container">{{t('compare.schutzhuelle')}}</p>
                <p v-if="data.compare_schutzhuelle" class="value">{{ data.compare_schutzhuelle }}</p>
                <p v-else class="value">–</p>
            </li>
        </ul>
    </div>
</template>

<script>
    import { FireI18n } from 'fire-js-i18n';
    import InlineSvg from 'vue-inline-svg';
    export default {
        name: 'ItemSpecification',
        inject: ['tooltips'],
        components: {
            'inline-svg': InlineSvg
        },
        props: {
            data: null,
            topic: null,
        },
        methods: {
        t(key, options) {
            return FireI18n.t(key, options);
            },
        },
        mounted() {
        },
    }
</script>

<style lang="scss">
    .item-specs {
        padding-left: 40px;
        padding-right: 40px;

        h3 {
            font-size: 14px;
            font-weight: 500;
            line-height: 30px;
        }

        ul {
            li {
                display: flex;
                gap: 5px;
                font-size: 14px;
                line-height: 30px;

                .label-container, .value{
                    flex: 1;
                }

                .label {
                    font-weight: 200;
                }

                .value {
                    font-weight: 100;

                    @media ( min-width: 1024px ) and ( max-width: 1400px ) {
                        text-align: right;
                    }
                }
            }
        }
    }
</style>